import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { rupees, fmtDate, StatePill, PAYOUT_STATUS_LABEL } from "./EarningsPrimitives";

const MODE = { chat: "Chat", audio: "Audio", video: "Video" };

function Row({ label, value, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 py-2 border-b border-slate-100 last:border-0">
      <span className="text-xs uppercase tracking-widest font-bold text-slate-400">{label}</span>
      <span className="text-sm font-bold text-[#0A2540] text-right" data-testid={testid}>{value}</span>
    </div>
  );
}

export function EarningDetailDialog({ earning, onClose }) {
  const e = earning;
  return (
    <Dialog open={!!e} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="earning-detail-dialog">
        {e && (
          <>
            <DialogHeader>
              <DialogTitle style={{ fontFamily: "Poppins" }}>Consultation Earnings</DialogTitle>
              <DialogDescription>
                {MODE[e.mode] || e.mode} consultation · {e.duration_minutes} minutes
              </DialogDescription>
            </DialogHeader>
            <div className="rounded-2xl bg-[#FBF4DF] border border-[#F1E3B5] p-4 mb-2">
              <p className="text-[11px] uppercase tracking-widest font-bold text-[#0A2540]/70">Your Earnings</p>
              <p className="text-3xl font-extrabold text-[#0A2540]" style={{ fontFamily: "Poppins" }} data-testid="earning-detail-amount">{rupees(e.amount_paise)}</p>
            </div>
            <Row label="Status" value={<StatePill state={e.state} testid="earning-detail-state" />} />
            <Row label="Why" value={e.state_reason} testid="earning-detail-reason" />
            <Row label="Consultation" value={`#${e.consultation_id.slice(-8).toUpperCase()}`} />
            {e.completed_at && <Row label="Completed" value={fmtDate(e.completed_at, true)} testid="earning-detail-completed" />}
            {e.refund_window_expires_at && (e.state === "pending" || e.state === "available") && (
              <Row label={e.state === "pending" ? "Refund window ends" : "Refund window ended"} value={fmtDate(e.refund_window_expires_at, true)} testid="earning-detail-window" />
            )}
            {e.payout && (
              <>
                <Row label="Payout" value={e.payout.payout_reference || e.payout.payout_id} testid="earning-detail-payout-ref" />
                <Row label="Payout status" value={PAYOUT_STATUS_LABEL[e.payout.status] || e.payout.status} testid="earning-detail-payout-status" />
                {e.payout.paid_at && <Row label="Paid on" value={fmtDate(e.payout.paid_at, true)} testid="earning-detail-paid-at" />}
              </>
            )}
            {e.eligibility_basis === "legacy_created_at_fallback" && (
              <p className="mt-2 text-[11px] text-slate-400" data-testid="earning-detail-legacy-note">Older consultation — eligibility timed from the booking date.</p>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
